module.exports = __webpack_public_path__ + "img/poorter_hotel-021.31fd05fa.jpg";